<template>
    <table ref="tableRef" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th>Name</th>
                <th>Drivers</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
});

const tableRef = ref(null);

const datatable = () => {
    window.jQuery(tableRef.value).dataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        order: [[0, 'asc']],
        columns: [
            {
                name: 'name',
                searchable: false,
                orderable: true,
                render: function(data, type, row) {
                    return row.computed_name;
                }
            },
            {
                data: 'drivers',
                name: 'drivers',
                searchable: false,
                orderable: false,
                width: '200px',
                render: function(data, type, row) {
                    return data.length;
                }
            },
            {
                data: 'actions',
                searchable: false,
                orderable: false,
                width: '200px',
            }
        ]
    });
};

onMounted(() => {
    datatable();
});
</script>
